export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11390.1f5330b6.jpg";